import { ConnectedProps } from "react-redux";
import * as Yup from "yup";
import { connect } from "react-redux";
import { RootState } from "../../store";
import { getListMedia } from "@/store/media/media.action";
import { useEffect, useState } from "react";
import { formatTimestampToAgo, useDebounce } from "../../utils";
import { generateBaseUrl, getThumbnailUrlUtil } from "@/utils/mediaUtils";
import { secondsToHms } from "../../utils";
import noImage from "../../assets/icons/svg/no-image.svg";
import { PublishedIcon } from "..";
import { useFormik } from "formik";
import { NotebookPen } from "lucide-react";
import { Skeleton } from "..";

interface RenderCreateMetaPresetProps {
  liveList?: any;
  item?: any;

  onSubmit?: (payload: any) => void;

  business?: any;
  medisList?: any;
  selectedMediaDetails?: any;
  openModal?: any;
  type?: string;
}

const PreviousMediaMeta = ({
  onSubmit,
  mediaList,
  getListMedia,
  selectedMediaDetails = null,
  openModal,
  type,
  isLoading,
}: Props) => {
  const [searchTerm, setSearchTerm] = useState<string>("");
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const [selectedMedia, setSelectedMedia] = useState<any>(
    selectedMediaDetails || null
  );
  const mendatoryFilter: any = {
    state: 10,
    status: 5,
    rows: 11,
    media_state: 1,
  };
  if (type === "social") {
    mendatoryFilter["socialembeds.status"] = 10;
    mendatoryFilter["socialembeds.job_type"] = [
      "youtube",
      "facebook",
      "instagram",
      "twitter",
      "linkedin",
    ];
  }

  const formik = useFormik({
    initialValues: {
      presetName: selectedMediaDetails?.name || "",
      visibility: selectedMediaDetails?.visibility || [],
      status: selectedMediaDetails?.status || 1,
    },
    validationSchema: Yup.object({
      // presetName: Yup.string().required('Preset Name is required'),
      // visibility: Yup.array().min(1, 'Visibility is required'),
      // status: Yup.number().required('Status is required'),
    }),
    onSubmit: (values) => {
      //console.log('values', values);
    },
  });

  useEffect(() => {
    if (debouncedSearchTerm) {
      getListMedia({
        ...mendatoryFilter,
        title: debouncedSearchTerm,
        key: "secondary",
      });
    } else {
      getListMedia({ ...mendatoryFilter, key: "secondary" });
    }
  }, [debouncedSearchTerm]);

  const getBasePermission = (permission: string): string => {
    return permission;
  };

  function processPermissionForSelect(array: string[]) {
    const newarray = array?.map((str) => {
      return getBasePermission(str);
    });
    return newarray;
  }

  const handlePermissionChange = (values: string[], key: string) => {
    const newProducers = values?.map((value) => value);

    formik.setFieldValue(key, newProducers);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const handleSelectMedia = async (media?: any) => {
    const currentMedia = media || selectedMedia;

    // Filter out social IDs that are present in socialembeds where status is not 10
    let filteredSocials = currentMedia?.socials || [];
    if (
      currentMedia?.socialembeds &&
      Array.isArray(currentMedia.socialembeds)
    ) {
      const socialEmbedIds = currentMedia.socialembeds
        .filter((embed: any) => embed.status !== 10)
        .map((embed: any) => embed.id);

      filteredSocials =
        currentMedia.socials?.filter(
          (social: any) => !socialEmbedIds.includes(social.id)
        ) || [];
    }

    const payload = {
      ...currentMedia,
      socials: filteredSocials,
      visibility: [...formik.values.visibility],
      status: formik.values.status,
      name: formik.values.presetName,
    };

    openModal(payload);
    onSubmit?.(payload);
  };

  useEffect(() => {
    const handleSelect = () => {
      handleSelectMedia();
    };
    window.addEventListener("selectMedia", handleSelect);
    return () => {
      window.removeEventListener("selectMedia", handleSelect);
    };
  }, [handleSelectMedia]);

  return (
    <>
      <div className="row">
        {/* Search Input */}
        <div
          className="bg-light border-bottom mb-4 px-3 py-2 pb-3 position-sticky z-9"
          style={{ marginTop: "-14px", top: "-14px" }}
        >
          <div className="position-relative">
            <label>Search</label>
            <input
              type="text"
              className="form-control"
              placeholder="Search media by title..."
              value={searchTerm}
              onChange={handleSearchChange}
              style={{ paddingRight: "40px" }}
            />
            {searchTerm && (
              <button
                className="btn position-absolute"
                style={{
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 10,
                }}
                onClick={handleClearSearch}
              >
                <i className="bi bi-x-circle"></i>
              </button>
            )}
          </div>
        </div>

        {/* Grid View */}
        <div className="row">
          {(() => {
            // Filter media based on social status

            const filteredMediaList =
              type === "social"
                ? mediaList?.filter((media: any) => {
                    // If no socials, include the media
                    if (!media.socials || media.socials.length === 0) {
                      return false;
                    }

                    // Separate denmark and non-denmark socials
                    const denmarkSocials = media.socials.filter(
                      (social: any) =>
                        social.job_type === "denmark" ||
                        social.job_type === "denmark_embed"
                    );
                    const nonDenmarkSocials = media.socials.filter(
                      (social: any) =>
                        social.job_type !== "denmark" &&
                        social.job_type !== "denmark_embed"
                    );

                    // If only denmark socials exist, include the media
                    if (
                      denmarkSocials.length > 0 &&
                      nonDenmarkSocials.length === 0
                    ) {
                      return false;
                    }
                    if (
                      denmarkSocials.length > 0 &&
                      nonDenmarkSocials.length > 0
                    ) {
                      const hasNonDenmarkStatus10 = nonDenmarkSocials.some(
                        (social: any) => social.status === 10
                      );
                      return hasNonDenmarkStatus10;
                    }

                    // If non-denmark socials exist, check if at least one has status 10
                    if (nonDenmarkSocials.length > 0) {
                      const hasNonDenmarkStatus10 = nonDenmarkSocials.some(
                        (social: any) => social.status === 10
                      );
                      return hasNonDenmarkStatus10;
                    }

                    return true;
                  }) || []
                : mediaList;

            // Add a blank card at the start
            const mediaListWithBlank = [
              { id: "__blank__", title: "", isBlank: true },
              ...filteredMediaList,
            ];
            return isLoading ? (
              <Skeleton type="table" count={6} />
            ) : mediaListWithBlank && mediaListWithBlank.length > 0 ? (
              mediaListWithBlank.map((media: any) => (
                <div
                  key={media.id}
                  className="col-3 mb-3"
                  style={{ cursor: "pointer", minHeight: "180px" }}
                >
                  <div
                    className={`card position-relative h-100 catRow ${
                      (selectedMedia === null && media.isBlank) ||
                      (selectedMedia?.id === media.id && !media.isBlank)
                        ? ""
                        : ""
                    }`}
                    onClick={() => {
                      media.isBlank
                        ? setSelectedMedia(null)
                        : setSelectedMedia(media);
                      handleSelectMedia(media);
                    }}
                  >
                    {media.isBlank ? (
                      <div className="d-flex flex-column justify-content-center align-items-center h-100 gap-3 catRow">
                        <NotebookPen size={24} className="iconColor" />
                        <span className="mt-2 text-uppercase fs-5">
                          Create Blank
                        </span>
                      </div>
                    ) : (
                      <>
                        <div className="position-relative mb-2">
                          <div
                            className="rounded ratio ratio-16x9 border bg-secondary"
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={
                                (() => {
                                  const thumbId =
                                    media?.orientation === 2
                                      ? media?.images?.portrait ||
                                        media?.images?.thumb
                                      : media?.images?.thumb;
                                  return thumbId && generateBaseUrl(media)
                                    ? getThumbnailUrlUtil({
                                        media,
                                        id: thumbId,
                                        source: media?.source,
                                      })
                                    : noImage;
                                })()
                              }
                              alt={media.title}
                              className="object-fit-cover position-absolute top-50 start-50 translate-middle"
                              style={{ width: "100%", height: "100%" }}
                            />

                            <div className="media-hover-overlay play-button">
                              <i
                                className="bi bi-play-fill text-white"
                                style={{ fontSize: "2rem" }}
                              ></i>
                            </div>
                          </div>
                          <span className="position-absolute bottom-0 end-0 bg-dark text-light px-1 fs-6">
                            {secondsToHms(media.meta?.duration)}
                          </span>
                        </div>
                        <div className="px-2 d-flex flex-column">
                          <span className="card-title text-truncate mb-1 anchor">
                            {media.title}
                          </span>
                          <small className="text-muted mb-1">
                            Published on: {formatTimestampToAgo(media.ct)}
                          </small>
                        </div>
                        {type !== "meta" && (
                          <div className="px-2">
                            {media?.socials && media?.socials?.length > 0 && (
                              <div className="row g-1">
                                {media?.socials
                                  ?.filter(
                                    (social: any) =>
                                      social?.job_type !== "denmark" &&
                                      social?.status === 10 &&
                                      social?.job_type !== "denmark_embed"
                                  )
                                  ?.slice(0, 4)
                                  ?.map((social: any, idx: number) => (
                                    <div className="col-6" key={idx}>
                                      <div className="d-flex flex-row gap-1">
                                        <PublishedIcon
                                          job_type={social?.job_type}
                                          status={social?.status}
                                          size={12}
                                        />
                                        <span
                                          className="text-muted"
                                          style={{ fontSize: "12px" }}
                                        >
                                          {social?.channel_name}
                                        </span>
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center py-5">
                <div className="text-muted">
                  <i className="bi bi-search fs-1 mb-3 d-block"></i>
                  <p>No media found</p>
                  {searchTerm && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={handleClearSearch}
                    >
                      Clear search
                    </button>
                  )}
                </div>
              </div>
            );
          })()}
        </div>
      </div>
    </>
  );
};

const mapState = (state: RootState) => ({
  categories: state.app.categories,
  agencies: state.app.agencies,
  categoryList: state.media.categoryList,
  category: state.app.category,
  language: state.app.language,
  tag: state.app.tag,
  cast: state.app.cast,
  genre: state.app.genre,
  mostFrequentUsers: state.users.mostFrequentUsers,
  mostFrequentEditor: state.users.mostFrequentEditor,
  presetList: state.media.presetList.list,
  liveList: state.media.liveList.list,
  mediaList: state.media.secondaryMediaList.list,
  isLoading: state.media.secondaryMediaList.isLoading,
});

const mapDispatch = {
  getListMedia,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector> & RenderCreateMetaPresetProps;
export default connector(PreviousMediaMeta);
